<template>
  <el-dialog title="提货订单审核" class="global-dialog" :visible.sync="showDlg" width="600px" :before-close="handleClose">

    <div class="dlg-content">
      <el-form class="global-form  " v-loading="loading" style="padding:30px 40px 20px 20px" :model="formData"
        ref="form2" :rules="rules" label-width="140px">
        <el-row>
          <el-col :span="24">
            <el-form-item prop="deliveryState" label="审核状态">
              <el-select v-model="formData.deliveryState" placeholder="请选择审核状态">
                <el-option v-for="[key, value] of deliveryStateMap" :key="key" :label="value" :value="key"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button @click="submitDlg" type="primary">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { deliveryState } from '../../utils/dict'
import { deepClone } from '../../utils/utils'
export default {
  name: 'PurchaseOrdersDialog',
  props: {
    showDlg: {
      type: Boolean,
      default: false
    },
    dataInfo: {
      type: Object,
      default: () => { }
    }
  },
  data() {
    return {
      formData: {
        deliveryId: '', // 提货ID
        deliveryState: '' // 发货状态1待审核2待发货3已发货4已驳回
      },
      loading: false,
      rules: {
        deliveryState: [{ required: true, message: '请选择审核状态' }]
      }
    }
  },
  created() {
    this.formData.deliveryId = this.dataInfo.deliveryId
  },
  computed: {
    deliveryStateMap() {
      const data = deepClone(deliveryState)
      data.delete('1')
      data.delete('3')
      return data
    }
  },
  methods: {
    handleClose() {
      this.$emit('update:showDlg', false)
    },
    submitDlg() {
      this.$refs.form2.validate().then(() => {
        console.log(this.formData)
        this.loading = true
        const url = this.$apis.purchaseDelivery.approveYcDelivery
        this.$axios.post(url, this.formData).then(() => {
          this.$emit('successSave')
          this.handleClose()
        }).finally(() => {
          this.loading = false
        })
      })
    }

  }
}
</script>

<style scoped lang="scss">
.el-select {
  width: 100%;
}

.row-wrap {
  display: flex;
  flex-wrap: wrap;
}
</style>
